import React from 'react';
import Button from '../ui/Button';

interface SettingHeaderProps {
    heading: string;
    para?: string;
    onClick?: () => void;
    btnTxt?: string;
    className?: string;
    children?: React.ReactNode;
}

const SettingHeader = ({
    heading,
    para,
    onClick,
    btnTxt,
    className,
    children

}: SettingHeaderProps) => {
    return (
        <div className={`space-y-4 ${className}`}>
            {/* Header Container */}
            <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4 lg:gap-8">
                {/* Content Section */}
                <div className="flex-1 min-w-0">
                    <h3 className="text-xl font-semibold text-gray-900 dark:text-white truncate">
                        {heading}
                    </h3>
                    {para && (
                        <p className="mt-1 text-sm text-gray-600 dark:text-gray-300">
                            {para}
                        </p>
                    )}
                </div>
                {onClick && (
                    <div className="flex justify-end ">
                        <Button
                            btnStyle="brandBtn"
                            onClick={onClick}
                        >
                            {btnTxt}
                        </Button>
                    </div>
                )}
                <div>{children}</div>


            </div>

            {/* Divider */}
            <div className="border-t border-gray-200 dark:border-gray-700" />
        </div>
    );
};

export default SettingHeader;